import { AboutUs } from './components/AboutUs'
import { BecomeAClient } from './components/BecomeAClient'
import { BecomeAnExpert } from './components/BecomeAnExpert'
import { Footer } from './components/Footer'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { OurHistory } from './components/OurHistory'
import { Products } from './components/Products'
import { WhyUs } from './components/WhyUs'

export const scrollToComponent = (id: string) => {
  const element = document.getElementById(id)
  if (element) {
    window.scrollTo({
      top: element.offsetTop - 88,
      behavior: 'smooth'
    })
  }
}

export const Landing = () => {
  document.title = 'Trust'
  return (
    <>
      <Header />
      <Hero />
      <AboutUs id="about-us" />
      <OurHistory id="our-history" />
      <WhyUs id="why-us" />
      <Products id="products" />
      <BecomeAnExpert id="become-an-expert" />
      <BecomeAClient id="become-a-client" />
      <Footer />
    </>
  )
}
